import { FolderOpen, ArrowUpCircle, Undo2, FileText, UserPlus, Paperclip, Gavel, RotateCcw, PenTool, Sparkles, MessageSquareQuote, Archive } from "lucide-react";
import { fmt } from "./legalUtils";

const ICON = { open: [FolderOpen, "bg-sky-500"], escalate: [ArrowUpCircle, "bg-amber-500"], return: [Undo2, "bg-rose-500"], minute: [FileText, "bg-slate-500"],
  party: [UserPlus, "bg-indigo-500"], statement: [MessageSquareQuote, "bg-indigo-400"], attach: [Paperclip, "bg-slate-400"], close: [Gavel, "bg-[#0f1f3d]"],
  reopen: [RotateCcw, "bg-sky-600"], sign: [PenTool, "bg-emerald-600"], ai: [Sparkles, "bg-fuchsia-500"], archive: [Archive, "bg-slate-600"] };

export const LegalTimeline = ({ events }) => (
  <ol className="relative space-y-4 border-r-2 border-slate-200 pr-6" data-testid="legal-timeline">
    {[...(events || [])].reverse().map((e) => {
      const [Icon, bg] = ICON[e.kind] || ICON.minute;
      return (
        <li key={e.id} className="relative">
          <span className={`absolute -right-[37px] top-0 grid h-7 w-7 place-items-center rounded-full ring-4 ring-white ${bg}`}><Icon className="h-3.5 w-3.5 text-white" /></span>
          <p className="text-sm font-bold text-slate-800">{e.text}</p>
          <p className="text-[11px] text-slate-500">{e.by} · {fmt(e.at)}</p>
          {e.note && <p className="mt-1 rounded-lg bg-slate-50 px-2 py-1 text-xs text-slate-600">«{e.note}»</p>}
        </li>
      );
    })}
  </ol>
);
